<template>
  <div class="container">
    <h3>Inicializando com o Docker</h3>
    <p>
      Para rodar o DFe Sync, você precisará criar um container a partir da imagem disponibilizada em <a
      target="_blank"
      href="https://gallery.ecr.aws/u5b5p7x0/dfe-sync">
      https://public.ecr.aws/u5b5p7x0/dfe-sync:latest</a>.
      Certifique-se de estar utilizando a versão mais recente. Assumindo que o Docker está devidamente instalado e
      rodando no servidor:
    </p>
    <p>
      Para inicializar o container, utilize o comando a seguir. Lembre-se de escolher as opções de download desejadas
      utilizando as variáveis de ambiente disponíveis.
    </p>
    
    <pre><code>docker run -v &lt;your_path&gt;:/app/documents -e PLATFORM_TOKEN=&lt;your_token&gt; -e XML=true public.ecr.aws/u5b5p7x0/dfe-sync:latest</code>
    </pre>
    
    <p>
      Note que é necessário utilizar ao menos uma variável de ambiente, além da variável obrigatória <code>PLATFORM_TOKEN</code>.
      No exemplo acima, foi utilizada a variável de ambiente <code>XML</code>.
    </p>
    <p>Veja abaixo mais opções disponíveis:</p>
    
    <table class="table table-borderless table-dfe">
      <thead>
      <tr>
        <th>Opção</th>
        <th>Descrição</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>PLATFORM_TOKEN</td>
        <td>Refere-se ao token para utilizar a API. <a href="https://bkps.atlassian.net/l/c/D2eedwW0">Clique aqui</a>
          para saber como obter o token.
        </td>
      </tr>
      <tr>
        <td>JSON</td>
        <td>Salva os documentos no formato json</td>
      </tr>
      <tr>
        <td>PDF</td>
        <td>Salva os documentos no formato pdf</td>
      </tr>
      <tr>
        <td>XML</td>
        <td>Salva os documentos no formato xml</td>
      </tr>
      <tr>
        <td>XML_BROBOT</td>
        <td>Salva os documentos no formato xml_brobot</td>
      </tr>
      <tr>
        <td>START_DATE</td>
        <td>Inicia a busca a partir desta data (formato yyyy-mm-dd HH:MM:SS.Z)</td>
      </tr>
      </tbody>
    </table>
    <hr>
    
    <h3 id="pastas">Pastas</h3>
    <p>A estrutura de pastas utilizada pelo DFe Sync é a seguinte:</p>
    <pre class="language-bash"><code class="prism  language-bash"><span class="token operator">|</span>-- app
    <span class="token operator">|</span>-- documents
        <span class="token operator">|</span>-- json
        <span class="token operator">|</span>-- pdf
        <span class="token operator">|</span>-- xml
        <span class="token operator">|</span>-- xml_brobot</code>
    </pre>
    
    <h3 id="mapeamento-de-volumes">Mapeamento de volumes</h3>
    <p><code>documents</code> é o local onde serão salvos os documentos sincronizados do DFe. Certifique-se de que esta
      pasta está mapeada corretamente no seu servidor. Caso contrário, uma vez que o container for excluído, <strong>todos
        os documentos</strong> serão excluídos permanentemente.</p>
    <p>Para fazer isso, basta mapear o caminho desejado e incluir no lugar de <code>&lt;your_path&gt;</code> no exemplo
      do comando recortado abaixo:</p>
    <pre><code>-v &lt;your_path&gt;:/app/documents
</code></pre>
    <hr>
    
    <p><code>logs</code> é o local onde será salvo o log deste container. Certifique-se de que esta pasta está mapeada
      corretamente no seu servidor. Caso contrário, uma vez que o container for excluído, <strong>todos os
        documentos</strong> serão excluídos permanentemente.</p>
    <p>Para fazer isso, basta mapear o caminho desejado e incluir no lugar de <code>&lt;your_path&gt;</code> no exemplo
      do comando recortado abaixo:</p>
    <pre><code>-v &lt;your_path&gt;:/app/logs
</code></pre>
    <hr>
    
    <h3 id="exemplo">Exemplo</h3>
    <pre><code>docker run -v ~/Downloads/dfe-sync:/app/documents -e PLATFORM_TOKEN=KNsgK3n2aPEkmGqKivLCyfhs -e XML=true public.ecr.aws/u5b5p7x0/dfe-sync:latest
</code></pre>
    <h3 id="resultado">Resultado</h3>
    <p><img class="img-fluid"
            src="https://cdn.discordapp.com/attachments/931500259241246750/955455851492180018/unknown.png"
            alt="resultado dfe-sync">
    </p>
  </div>
</template>

<script>
export default {
  name: 'DfeSync'
}
</script>

<style scoped>
  p {
   color: black
  }
  
  code, pre, samp {
    font-family: Roboto Mono, Lucida Sans Typewriter, Lucida Console, monaco, Courrier, monospace;
    font-size: .85em
  }

  code *, pre *, samp * {
    font-size: inherit
  }
  
  code {
    background-color: rgba(0, 0, 0, .05);
    border-radius: 3px;
    padding: 2px 4px
  }

</style>